// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"235fe7e9","644":"235fe7e9","817":"235fe7e9","933":"c5836091"}[chunkId] + ".chunk.css";
};